module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/natalia-sladewska-ac8009c378dc65b7dbd1011ffb801e91.webp";